<section>

    <div class="login-container">

        <div id="sign-in-widget"></div>

        @if (!hideNavigation) {
            <nav>
                <a routerLink="/register">New User</a>
                <a routerLink="/what-is-mysoftpro">What is mySoftPro?</a>
            </nav>
        } @else {
            <kendo-loader [class.height100]="hideNavigation" [type]='"converging-spinner"' size="large">
            </kendo-loader>
        }

    </div>

</section>


